import { forwardRef } from "react";
import "./ImagePreview.css"

const ImagePreviewDialog = forwardRef(({ image }, ref) => {
  return (
    <dialog ref={ref} className="image-preview-dialog">
      <button className="close-btn" onClick={() => ref.current?.close()}>
        ✕
      </button>

      <img src={image} alt="Preview" className="preview-image" />
    </dialog>
  );
});

export default ImagePreviewDialog;
